export const reportStatusesColors = {
  'top_up_load_status.in_progress': 'gray',
  'top_up_load_status.success': 'green',
  'top_up_load_status.closed_with_errors': 'red',
  'top_up_load_status.waiting_for_load_date': 'orange',
  'top_up_load_status.waiting_for_payment': 'orange',
  'top_up_load_status.payment_confirmed_waiting_for_load_date': 'orange',
  'top_up_load_status.payment_not_received': 'red',
  'top_up_load_status.expired': 'gray',
  'top_up_load_status.canceled': 'gray',
  'top_up_request_status.success': 'green',
  'top_up_request_status.error': 'red',
  'top_up_request_status.in_progress': 'gray',
  'top_up_request_status.not_started': 'gray',
  'top_up_request_status.expired': 'gray',
  'top_up_request_status.canceled': 'gray'
};
